import "./bootstrap/bootstrap-icons.css";

/* ////////// SECTIONS ////////// */
import "./css/section-hero-slider.css";
import "./js/section-hero-slider.js";

import "./js/section-top-button.js";

import "./js/section-features.js";

import "./js/section-accordion-content.js";

import "./js/section-sidebar.js";

/* ////////// PRODUCT ////////// */
import "./js/product-slider-gallery.js";

import "./js/product-slider-related.js";
import "./css/product-slider-related.css";

import "./css/product-filter.css";
import "./js/product-filter.js";

import "./js/product-slider-bestseler.js";
import "./css/product-slider-bestseler.css";

import "./js/product-single.js";

import "./js/product-price.js";

import "./js/product-status.js";

import "./js/product-button-addtocart.js";

import "./js/product-review.js";

import "./css/product-tab.css";
import "./js/product-tab.js";

/* ////////// POST ////////// */
import "./css/post-slider-featured.css";
import "./js/post-slider-featured.js";

import "./css/post-slider-related.css";
import "./js/post-slider-related.js";

/* ////////// SWIPPER ////////// */
import 'swiper/css/bundle';         // Swiper'ın tüm CSS stilleri
import Swiper from 'swiper/bundle'; // Swiper'ın JS çekirdeği
window.Swiper = Swiper; // Temadaki diğer JS dosyalarının Swiper'ı tanıyabilmesi için global yapıyoruz

/* ////////// BASIC ////////// */
import "./css/header.css";
import "./js/header.js";

import "./css/footer.css";

import "./css/form7.css";
import "./js/form7.js";

import "./style.css";

